export const BRAND = {
  name: "The I Choose Movement",
  tagline: "It's Not Too Late to Choose You.",
  founder: "Crystal Purdue",
  city: "Flossmoor, IL",
  phone: "312-758-6437",
  email: "crystalpurdue29@gmail.com",
  calendly: "https://calendly.com/crystalpurdue30",
  shop: "https://i-choose-movement-llc.square.site",
  domain: "ichoosemovement.com",
  social: {
    instagram: "https://instagram.com/i_choosecrys",
    tiktok: "https://tiktok.com/@i_choosecrys",
    facebook: "https://facebook.com/i_choosecrys",
  },
  images: {
    headshot:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/nqr4nrzc_IMG_5147.jpg",
    portraitJoy:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/7hmgg41v_4.jpg",
    speaking:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/ppntum8i_thumbnail%20%281%29.jpg",
    workshop:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/xxjv5t2h_Event%20with%20the%20girls.jfif",
    products:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/nfxaihdw_Card1.jfif",
    eventTee:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/erqtftmp_Event%201.jfif",
    eventGroup:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/pycr6wfc_Event%202.jfif",
    eventAudience:
      "https://customer-assets.emergentagent.com/job_choose-you-2/artifacts/8qfygq0g_Event%203.jfif",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/speaking", label: "Speaking", testid: "nav-speaking" },
  { to: "/workshops", label: "Workshops", testid: "nav-workshops" },
  { to: "/coaching", label: "Coaching", testid: "nav-coaching" },
  { to: "/shop", label: "Shop", testid: "nav-shop" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Ms. Crystal, when I use the 'I Choose' cards, it's usually 99% of the time the card is what the client needs for things they are going through and the place they are in. Your movement speaks wisdom, clarity, and empowerment.",
    name: "A practitioner",
    role: "Using the I Choose cards in client sessions",
  },
  {
    quote:
      "I used the cards in both groups yesterday and let me tell you — they loved them! I can't wait to purchase the other edition!",
    name: "A facilitator",
    role: "After back-to-back group sessions",
  },
  {
    quote:
      "Ms. Crystal, I got another praise report, my friend. I just finished a presentation for a lunch-and-learn on self-medicating — the numbing effect. I used the I Choose cards to close them out, and they loved your cards.",
    name: "A speaker",
    role: "After a corporate lunch-and-learn",
  },
  {
    quote:
      "Ms. Crystal, we have you to thank. That's why so many of us have testimonies — because of your love and guidance. You show us seeing the truth leads to deeper healing. Your cards be having me healed in the way I can't see.",
    name: "A community member",
    role: "On the love, guidance, and the cards",
  },
];

export const TOPICS = [
  {
    title: "It's Not Too Late to Choose You",
    desc: "A signature keynote for women at the crossroads. Reclaiming voice, time, and direction after years of caretaking.",
  },
  {
    title: "Your Choices Are Your Future",
    desc: "A youth-facing talk that flips the script: identity is not assigned, it's chosen.",
  },
  {
    title: "The Architecture of an Intentional Life",
    desc: "Frameworks for organizational leaders, wellness teams and faith communities.",
  },
  {
    title: "Brave Conversations, Bolder Choices",
    desc: "Mental health and resilience built around honest dialogue and self-permission.",
  },
];

export const WORKSHOPS = [
  {
    key: "women",
    title: "For Women",
    blurb:
      "A room of women remembering who they were before everyone needed something from them. Reflective, honest, restorative.",
  },
  {
    key: "youth",
    title: "For Youth",
    blurb:
      "Identity, voice, and choice — delivered with the warmth of a mentor and the clarity of a coach.",
  },
  {
    key: "school",
    title: "For Schools",
    blurb:
      "Built for assemblies, advisory blocks, and leadership retreats. Curriculum-friendly, outcome-driven.",
  },
  {
    key: "wellness",
    title: "For Wellness & Faith Communities",
    blurb:
      "Trauma-aware, intentional, designed to fit inside retreats, women's ministries, and wellness conferences.",
  },
];

export const COACHING_OUTCOMES = [
  "Recover the voice you traded for everyone else's comfort",
  "Make one bold choice that re-routes the next ten years",
  "Rebuild your day around what you actually want",
  "Replace permission-seeking with self-authorization",
  "Translate breakthrough into a life that looks different by next quarter",
];

export const PRODUCTS = [
  {
    title: "I Choose — Original Affirmation Deck",
    desc: "52 cards. One a week. A year of choosing you.",
    href: "https://i-choose-movement-llc.square.site",
  },
  {
    title: "I Choose Us — Couple Edition",
    desc: "Affirmations and prompts to choose each other on purpose.",
    href: "https://i-choose-movement-llc.square.site",
  },
  {
    title: "I Choose Me — School Age Edition",
    desc: "Language and identity-building cards for young people.",
    href: "https://i-choose-movement-llc.square.site",
  },
  {
    title: "I Choose at Work — Workplace Edition",
    desc: "Tools for leaders and teams that want intentional cultures.",
    href: "https://i-choose-movement-llc.square.site",
  },
  {
    title: "The I Choose Planner",
    desc: "A weekly planner designed around intentional choosing, not endless to-do lists.",
    href: "https://i-choose-movement-llc.square.site",
  },
];
